var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 420.94 413.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .63;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-2, .cls-6, .cls-7, .cls-8, .cls-11 {\n        fill: #2b1f5d;\n      }\n\n      .cls-2 {\n        opacity: .22;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #6cade3;\n      }\n\n      .cls-4, .cls-5 {\n        opacity: .72;\n      }\n\n      .cls-5, .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        opacity: .39;\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-7 {\n        opacity: .25;\n      }\n\n      .cls-18 {\n        stroke: #4e67c3;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-18, .cls-10 {\n        fill: #4e67c3;\n      }\n\n      .cls-8 {\n        opacity: .13;\n      }\n\n      .cls-19 {\n        opacity: .28;\n      }\n\n      .cls-20 {\n        opacity: .24;\n      }\n\n      .cls-21 {\n        opacity: .47;\n      }\n\n      .cls-22 {\n        opacity: .46;\n      }\n\n      .cls-23 {\n        opacity: .42;\n      }\n\n      .cls-9, .cls-24, .cls-25 {\n        opacity: .54;\n      }\n\n      .cls-9, .cls-12, .cls-25 {\n        fill: #c4c6ff;\n      }\n\n      .cls-26 {\n        opacity: .61;\n      }\n\n      .cls-27 {\n        opacity: .49;\n      }\n\n      .cls-13 {\n        fill: #ff5d7a;\n      }\n\n      .cls-15 {\n        fill: #ffc35e;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 206.66,
    cy: 206.66,
    r: 206.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 312.59,
    cy: 176.8,
    r: 39.08,
    transform: "translate(67.64 439.43) rotate(-76.49)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 206.66,
    cy: 206.66,
    r: 206.66
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m188.99,12.77v240.04h187.31V12.77h-187.31Zm186.25,238.99h-185.19V13.83h185.19v237.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m369.28,21.77h-173.28v222.04h173.28V21.77Zm-1.06,220.99h-171.16v-88.07h171.16v88.07Zm0-89.13h-171.16v-69.04h171.16v69.04Zm0-70.09h-171.16V22.83h171.16v60.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 19.05,
    y: 263.77,
    width: 367.83,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 19.05,
    y: 287.81,
    width: 367.83,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.17,37.17c-1.05-.7-2.44-.49-3.24.44l-4.46-2.96c.54-.93.86-2.01.86-3.16,0-.81-.16-1.59-.44-2.3l4.64-2.57c.73.99,2.09,1.31,3.19.7,1.2-.66,1.63-2.17.97-3.37-.66-1.2-2.17-1.63-3.37-.97-1.1.61-1.55,1.94-1.1,3.08l-4.6,2.55c-.9-1.74-2.58-2.99-4.58-3.31v-4.82c1.22-.16,2.16-1.2,2.16-2.46,0-1.37-1.11-2.48-2.48-2.48s-2.48,1.11-2.48,2.48c0,1.26.94,2.3,2.16,2.46v4.75c-.12,0-.24-.02-.36-.02-1.95,0-3.69.88-4.84,2.27l-3.65-2.42c.54-1.1.2-2.46-.85-3.16-1.14-.76-2.68-.45-3.44.7-.76,1.14-.45,2.68.7,3.44,1.05.7,2.44.49,3.24-.44l3.62,2.4c-.67,1-1.07,2.21-1.07,3.5,0,1.06.27,2.06.73,2.94l-3.88,2.15c-.73-.99-2.09-1.31-3.19-.7-1.2.66-1.63,2.17-.97,3.37.66,1.2,2.17,1.63,3.37.97,1.1-.61,1.55-1.94,1.1-3.08l3.9-2.16c1.13,1.69,3.05,2.8,5.23,2.8.02,0,.04,0,.06,0v4.95c-1.22.16-2.16,1.2-2.16,2.46,0,1.37,1.11,2.48,2.48,2.48s2.48-1.11,2.48-2.48c0-1.26-.94-2.3-2.16-2.46v-4.99c1.8-.2,3.37-1.16,4.38-2.55l4.46,2.96c-.54,1.1-.2,2.46.85,3.16,1.14.76,2.68.45,3.44-.7.76-1.14.45-2.68-.7-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m346.7,113.11c-1.02-.68-2.37-.47-3.15.43l-4.34-2.88c.53-.9.83-1.95.83-3.07,0-.79-.16-1.54-.43-2.24l4.51-2.5c.71.96,2.03,1.27,3.1.68,1.16-.64,1.58-2.11.94-3.27-.64-1.16-2.11-1.58-3.27-.94-1.07.59-1.51,1.88-1.07,2.99l-4.46,2.48c-.87-1.69-2.51-2.91-4.45-3.22v-4.68c1.18-.15,2.1-1.16,2.1-2.39,0-1.33-1.08-2.41-2.41-2.41s-2.41,1.08-2.41,2.41c0,1.22.91,2.23,2.1,2.39v4.61c-.12,0-.23-.02-.35-.02-1.89,0-3.58.86-4.7,2.21l-3.54-2.35c.53-1.07.19-2.39-.83-3.07-1.11-.74-2.6-.43-3.34.68-.74,1.11-.43,2.6.68,3.34,1.02.68,2.37.47,3.15-.43l3.51,2.33c-.65.97-1.03,2.14-1.03,3.4,0,1.03.26,2.01.71,2.86l-3.77,2.09c-.71-.96-2.03-1.27-3.1-.68-1.16.64-1.58,2.11-.94,3.27.64,1.16,2.11,1.58,3.27.94,1.07-.59,1.51-1.88,1.07-2.99l3.78-2.1c1.1,1.64,2.96,2.71,5.08,2.71.02,0,.04,0,.05,0v4.81c-1.18.15-2.1,1.16-2.1,2.39,0,1.33,1.08,2.41,2.41,2.41s2.41-1.08,2.41-2.41c0-1.22-.91-2.23-2.1-2.39v-4.85c1.75-.19,3.27-1.13,4.26-2.48l4.33,2.87c-.53,1.07-.19,2.39.83,3.07,1.11.74,2.6.43,3.34-.68.74-1.11.43-2.6-.68-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m147.13,146.18c-.48-.32-1.12-.22-1.49.2l-2.06-1.36c.25-.43.39-.92.39-1.46,0-.38-.07-.73-.2-1.06l2.14-1.19c.34.46.96.6,1.47.32.55-.31.75-1,.45-1.55-.31-.55-1-.75-1.55-.45-.51.28-.72.89-.51,1.42l-2.12,1.17c-.41-.8-1.19-1.38-2.11-1.53v-2.22c.56-.07.99-.55.99-1.13,0-.63-.51-1.14-1.14-1.14s-1.14.51-1.14,1.14c0,.58.43,1.06.99,1.13v2.19c-.05,0-.11,0-.16,0-.9,0-1.7.41-2.23,1.05l-1.68-1.12c.25-.51.09-1.13-.39-1.45-.53-.35-1.23-.21-1.58.32-.35.53-.21,1.23.32,1.58.48.32,1.12.22,1.49-.2l1.67,1.11c-.31.46-.49,1.02-.49,1.61,0,.49.12.95.34,1.36l-1.79.99c-.34-.46-.96-.6-1.47-.32-.55.31-.75,1-.45,1.55.31.55,1,.75,1.55.45.51-.28.72-.89.51-1.42l1.8-1c.52.78,1.4,1.29,2.41,1.29,0,0,.02,0,.03,0v2.28c-.56.07-.99.55-.99,1.13,0,.63.51,1.14,1.14,1.14s1.14-.51,1.14-1.14c0-.58-.43-1.06-.99-1.13v-2.3c.83-.09,1.55-.54,2.02-1.18l2.06,1.36c-.25.51-.09,1.13.39,1.45.53.35,1.23.21,1.58-.32.35-.53.21-1.23-.32-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m62.79,104.06c-.87.03-1.57.7-1.65,1.54l-3.7.11c-.07-.74-.32-1.47-.78-2.12-.32-.46-.72-.83-1.17-1.12l1.59-3.3c.8.27,1.7-.1,2.08-.88.41-.85.05-1.88-.8-2.29s-1.88-.05-2.29.8c-.38.78-.1,1.71.61,2.18l-1.58,3.27c-1.2-.62-2.65-.66-3.91-.04l-1.92-2.72c.62-.57.74-1.54.24-2.25-.55-.77-1.61-.96-2.39-.41-.77.55-.96,1.61-.41,2.39.5.71,1.45.92,2.2.52l1.89,2.68c-.07.04-.14.08-.21.13-1.1.78-1.73,1.97-1.82,3.21l-3.02.09c-.13-.84-.87-1.47-1.74-1.44-.95.03-1.69.82-1.66,1.76.03.95.82,1.69,1.76,1.66.87-.03,1.57-.7,1.65-1.54l3-.09c.02.83.28,1.67.8,2.4.42.6.97,1.06,1.59,1.37l-1.33,2.76c-.8-.27-1.7.1-2.08.88-.41.85-.05,1.88.8,2.29s1.88.05,2.29-.8c.38-.78.1-1.71-.61-2.18l1.34-2.77c1.31.5,2.83.36,4.06-.51.01,0,.02-.02.03-.02l1.98,2.79c-.62.57-.74,1.54-.24,2.25.55.77,1.61.96,2.39.41.77-.55.96-1.61.41-2.39-.5-.71-1.45-.92-2.2-.52l-1.99-2.81c.94-.83,1.44-2,1.45-3.19l3.7-.11c.13.84.87,1.47,1.74,1.44.95-.03,1.69-.82,1.66-1.76s-.82-1.69-1.76-1.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m226.7,65.96v-10.04h.17c.72,0,1.31-.59,1.31-1.31s-.59-1.31-1.31-1.31h-7.16c-.72,0-1.31.59-1.31,1.31s.59,1.31,1.31,1.31h.17v10.04c-3.77,1.39-6.46,5.01-6.46,9.27,0,5.45,4.42,9.87,9.87,9.87s9.87-4.42,9.87-9.87c0-4.25-2.69-7.88-6.46-9.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m226.02,77.26c-3.13-.85-6.78-2.77-10.06-2.11,0,.12,0,.25,0,.37,0,4.16,3.37,7.53,7.53,7.53,3.32,0,6.13-2.14,7.13-5.12-1.55,0-3.1-.27-4.6-.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m244.77,130.7v-12.15h.21c.87,0,1.59-.71,1.59-1.59s-.71-1.59-1.59-1.59h-8.67c-.87,0-1.59.71-1.59,1.59s.71,1.59,1.59,1.59h.21v12.15c-4.57,1.68-7.82,6.07-7.82,11.22,0,6.6,5.35,11.95,11.95,11.95s11.95-5.35,11.95-11.95c0-5.15-3.26-9.54-7.82-11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m243.95,144.38c-3.79-1.02-8.21-3.36-12.17-2.55,0,.15-.01.3-.01.45,0,5.04,4.08,9.12,9.12,9.12,4.01,0,7.42-2.59,8.64-6.2-1.88,0-3.75-.33-5.57-.82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m256.25,57.21v-14.63h.25c1.05,0,1.91-.86,1.91-1.91s-.86-1.91-1.91-1.91h-10.44c-1.05,0-1.91.86-1.91,1.91s.86,1.91,1.91,1.91h.25v14.63c-5.5,2.02-9.42,7.3-9.42,13.5,0,7.94,6.44,14.38,14.38,14.38s14.38-6.44,14.38-14.38c0-6.2-3.92-11.48-9.42-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m255.27,73.68c-4.56-1.23-9.88-4.04-14.65-3.07,0,.18-.01.36-.01.54,0,6.06,4.91,10.98,10.97,10.98,4.83,0,8.93-3.12,10.4-7.46-2.26.01-4.51-.39-6.71-.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m328.25,40.04h-38.8v30.95c0,7.48,3.97,13.59,8.81,13.59h16.39c4.85,0,8.81-6.12,8.81-13.59v-22.34l4.78-8.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m294.54,60.67v9.56c0,5.8,4.75,10.55,10.55,10.55h3.08c5.8,0,10.55-4.75,10.55-10.55v-9.4c-7.91,1.21-15.93.65-24.17-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "317 51.96 317 51.08 316.81 51.08 316.81 46.43 315.93 46.43 315.93 51.08 310.01 51.08 310.01 51.96 315.93 51.96 315.93 61.25 310.01 61.25 310.01 62.13 315.93 62.13 315.93 70.8 310.01 70.8 310.01 71.67 315.93 71.67 315.93 76.96 316.81 76.96 316.81 71.67 317 71.67 317 70.8 316.81 70.8 316.81 62.13 317 62.13 317 61.25 316.81 61.25 316.81 51.96 317 51.96"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m373.14,251.83h-56.59c-1.83,0-3.34-1.5-3.34-3.34h0c0-1.83,1.5-3.34,3.34-3.34h56.59c1.83,0,3.34,1.5,3.34,3.34h0c0,1.83-1.5,3.34-3.34,3.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 257.39,
    y: 125.66,
    width: 163.55,
    height: 104.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 265.67,
    y: 130.97,
    width: 146.99,
    height: 94.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 358.86,
    y: 135.68,
    width: 49.4,
    height: 35.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m367.91,159.86s20.85-24.45,30.61-13.55c9.76,10.9-14.9,19.57-30.61,13.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m367.91,160.38v-1.06c7.65.06,23.27-8.53,23.43-8.62l.51.92c-.65.36-16.02,8.81-23.94,8.75Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 312.59,
    cy: 176.8,
    r: 43.13,
    transform: "translate(67.53 439.32) rotate(-76.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 312.59,
    cy: 176.8,
    r: 39.08,
    transform: "translate(67.64 439.43) rotate(-76.49)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m311.33,119.94h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m323.45,119.94h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m311.33,125.21h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m323.46,125.21h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m311.37,223.82h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m323.49,223.81h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m311.37,229.09h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m323.49,229.09h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m311.34,146.34h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m323.46,146.34h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.06,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m311.34,151.62h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m323.47,151.61h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m311.34,158.47h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m323.47,158.47h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m311.34,163.74h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m323.47,163.74h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m311.35,185.33h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.06,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m323.48,185.32h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m311.35,190.6h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m323.48,190.59h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m311.36,197.45h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m323.48,197.45h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m311.36,202.73h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.06h8.44c.58,0,1.05.47,1.05,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m323.48,202.72h-8.44c-.58,0-1.05-.47-1.05-1.05h0c0-.58.47-1.05,1.05-1.05h8.44c.58,0,1.05.47,1.06,1.05h0c0,.58-.47,1.05-1.05,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m311.83,175.8c5.4,4.78,10.07,8.91,10.07,17.53,0,8.62-4.66,12.76-10.06,17.54-5.52,4.89-11.78,10.44-11.83,21.12h6.58c.05-8.52,4.69-12.63,10.06-17.39,5.55-4.92,11.84-10.49,11.84-21.27,0-10.78-6.3-16.35-11.85-21.26-5.4-4.78-10.07-8.91-10.07-17.53,0-8.62,4.66-12.76,10.06-17.54,5.55-4.92,11.84-10.49,11.84-21.27h-6.57c0,8.63-4.66,12.76-10.06,17.54-5.55,4.92-11.84,10.49-11.84,21.27s6.3,16.35,11.85,21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m310.81,172.07c-5.55,4.92-11.84,10.49-11.84,21.27s6.3,16.35,11.85,21.26c5.37,4.75,10.01,8.86,10.07,17.38h6.58c-.07-10.68-6.32-16.22-11.85-21.11-5.4-4.78-10.07-8.91-10.07-17.53,0-8.62,4.66-12.76,10.06-17.54,5.55-4.92,11.84-10.49,11.84-21.27,0-10.78-6.3-16.35-11.85-21.26-5.4-4.78-10.07-8.91-10.07-17.53h-6.57c0,10.78,6.3,16.35,11.85,21.27,5.4,4.78,10.07,8.91,10.07,17.53,0,8.62-4.66,12.76-10.06,17.54Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 363.15,
    y: 169.72,
    width: 2.11,
    height: 16.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 336.83,
    y: 210.72,
    width: 28.71,
    height: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 360.86,
    y: 185.75,
    width: 45.39,
    height: 14.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 360.86,
    y: 205.1,
    width: 45.39,
    height: 14.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m402.25,191.09h-38.05c-.55,0-1-.45-1-1h0c0-.55.45-1,1-1h38.05c.55,0,1,.45,1,1h0c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m402.25,195.76h-38.05c-.55,0-1-.45-1-1h0c0-.55.45-1,1-1h38.05c.55,0,1,.45,1,1h0c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m402.25,209.78h-38.05c-.55,0-1-.45-1-1h0c0-.55.45-1,1-1h38.05c.55,0,1,.45,1,1h0c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m402.25,215.12h-38.05c-.55,0-1-.45-1-1h0c0-.55.45-1,1-1h38.05c.55,0,1,.45,1,1h0c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 325.09,
    y: 227.13,
    width: 38.83,
    height: 18.69
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m338.28,318.25s-2.67-32.02,11.95-31.27c14.61.75,3.39,24.37-11.95,31.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m338.65,318.63l-.74-.75c5.43-5.39,10.34-22.52,10.39-22.69l1.02.29c-.2.72-5.04,17.58-10.66,23.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m340.65,317.66s7.92-25.61,19-20.48c11.07,5.14-4.98,19.92-19,20.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m340.82,318.07l-.34-.81c5.88-2.48,15.03-14.21,15.12-14.33l.7.54c-.38.49-9.38,12.03-15.47,14.6Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m335.6,317.84s-26.64-2.99-23.67-14.83c2.98-11.84,20.5,1.16,23.67,14.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m335.97,317.6l-.73.49c-3.53-5.31-16.77-12.1-16.9-12.17l.4-.78c.55.28,13.57,6.97,17.23,12.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m337.45,316.5s-13.37-29.22.63-33.47c14-4.25,11.46,21.77-.63,33.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m337.93,316.72l-.95-.45c3.28-6.91,2.08-24.69,2.07-24.87l1.05-.07c.05.74,1.22,18.24-2.17,25.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m336.2,315.87s-26.59-18.04-16.82-28.94c9.76-10.9,21.09,12.67,16.82,28.94Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m336.72,315.81l-1.05.11c-.78-7.61-11.03-22.19-11.13-22.34l.86-.61c.43.61,10.51,14.96,11.32,22.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m352.37,320.96c1.6-.57,2.75-2.08,2.75-3.87,0-2.27-1.85-4.12-4.12-4.12h-26.78c-2.27,0-4.12,1.85-4.12,4.12,0,1.78,1.16,3.3,2.75,3.87-1.9,2.87-3.01,6.32-3.01,10.04,0,9.95,7.95,18.02,17.77,18.02s17.77-8.07,17.77-18.02c0-3.72-1.11-7.17-3.01-10.04Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 345.17,
    cy: 272.92,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m362.53,284.94c0,1.11-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 331.15,
    cy: 276.93,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.53,300.04h-74.79c-4.06,0-7.38-3.32-7.38-7.38h0c0-4.06,3.32-7.38,7.38-7.38h74.79c4.06,0,7.38,3.32,7.38,7.38h0c0,4.06-3.32,7.38-7.38,7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m194.51,285.28h-6.62c-4.12,4.94-8.26,9.88-12.45,14.76h6.64c4.18-4.89,8.31-9.82,12.42-14.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m168.67,285.28h-8.24c-5.26,4.88-10.5,9.8-15.69,14.76h11.03c4.39-4.83,8.67-9.77,12.89-14.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m172.49,283.95s-31.4,6.82-32.56-7.76c-1.16-14.58,23.72-6.54,32.56,7.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m172.81,283.53l-.65.84c-6.05-4.68-23.68-7.31-23.86-7.33l.15-1.04c.74.11,18.08,2.7,24.35,7.54Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m176.99,282.98s20.85-24.45,30.61-13.55c9.76,10.9-14.91,19.57-30.61,13.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m176.99,283.51v-1.06c7.65.06,23.27-8.53,23.43-8.62l.51.92c-.65.36-16.02,8.81-23.94,8.75Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 165.94,
    cy: 267.49,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 179.96,
    cy: 262.81,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 199.98,
    cy: 250.8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 149.25,
    cy: 258.81,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m133.23,266.82c0,1.11-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m209.24,151.23l3.88-15.87c1.48-6.04-1.47-12.37-7.03-16.8.39-.6.69-1.27.87-2.01h0c.86-3.52-1.32-7.1-4.83-7.96l-1.46-.36,4.34-17.75,1.21.3c1.96.48,3.96-.73,4.43-2.69.48-1.96-.73-3.96-2.69-4.43l-19.47-4.76c-1.96-.48-3.96.73-4.43,2.69-.48,1.96.73,3.96,2.69,4.43l1.21.3-4.34,17.75-1.46-.36c-3.52-.86-7.1,1.32-7.96,4.83h0c-.18.73-.22,1.47-.15,2.18-6.98,1.36-12.51,5.62-13.98,11.67l-24.52,100.4c-3.91,1.07-7.15,4.17-8.18,8.37h0c-1.5,6.15,2.3,12.42,8.45,13.92l42.26,10.32c6.15,1.5,12.42-2.3,13.92-8.45,1.03-4.2-.42-8.44-3.4-11.2l12.29-50.33c42.42,16.94,61.38,58.9,46.27,111.18-2.67,9.38,1.15,17.26,10.12,17.04,8.93-.2,20.69-10.5,24.09-22.33,20.14-69.68-9.58-124.25-72.12-140.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m188.75,235.09c-18.06-2.5-35.57-7.95-52.88-13.69l-.34,1.39c-3.91,1.07-7.15,4.17-8.18,8.37h0c-1.5,6.15,2.3,12.42,8.45,13.92l42.26,10.32c6.15,1.5,12.42-2.3,13.92-8.45,1.03-4.2-.42-8.44-3.4-11.2l.16-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m264.04,274.43c-.22-14.38-3.45-28.89-9.24-42.05-10.84-24.63-30.35-45.27-54.68-56.83-.47,2.3-.92,4.62-1.32,6.98,0,.91.01,1.83.07,2.73.61.34,1.21.7,1.8,1.08l.22-.91c42.42,16.94,61.38,58.9,46.27,111.18-2.44,8.57.55,15.87,7.93,16.9,4.77-12.63,9.16-25.52,8.96-39.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m302.35,338.89h-6.04c-2.58-8.67-9.76-16.56-20.24-22.97h9.17c4.51,0,8.21-3.69,8.21-8.21s-3.69-8.21-8.21-8.21h-68.46c-3.42-.2-6.9-.32-10.42-.32s-7,.11-10.42.32h-68.46c-4.51,0-8.21,3.69-8.21,8.21s3.69,8.21,8.21,8.21h9.17c-10.48,6.42-17.66,14.31-20.24,22.97h-6.04c-3.42,0-6.22,2.8-6.22,6.22s2.8,6.22,6.22,6.22h192c3.42,0,6.22-2.8,6.22-6.22s-2.8-6.22-6.22-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m302.35,338.89h-6.04c-.5-1.66-1.16-3.29-1.99-4.89H118.38c-.82,1.6-1.49,3.23-1.99,4.89h-6.04c-3.42,0-6.22,2.8-6.22,6.22s2.8,6.22,6.22,6.22h192c3.42,0,6.22-2.8,6.22-6.22s-2.8-6.22-6.22-6.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 191.08,
    y: 97.38,
    width: 2.11,
    height: 17.55,
    transform: "translate(43.42 267.61) rotate(-76.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "206.33 117.53 174.29 109.7 173.79 111.75 198.71 117.84 174.13 229.94 176.19 230.39 200.77 118.34 205.83 119.58 206.33 117.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.01,
    y: 201.97,
    width: 2.11,
    height: 54.62,
    transform: "translate(-99.12 332.3) rotate(-76.27)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 136.63,
    y: 315.39,
    width: 139.44,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 116.39,
    y: 338.36,
    width: 178.83,
    height: 1.06
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 285.57,
    cy: 249.98,
    r: 23.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m292.29,243.26c3.71,3.71,3.71,9.73,0,13.44-3.71,3.71-9.73,3.71-13.44,0-3.71-3.71-3.71-9.73,0-13.44,3.71-3.71,9.73-3.71,13.44,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m285.57,268.67c-4.79,0-9.57-1.82-13.22-5.47-7.29-7.29-7.29-19.15,0-26.44,7.29-7.29,19.15-7.29,26.44,0h0c3.53,3.53,5.48,8.22,5.48,13.22s-1.94,9.69-5.48,13.22c-3.64,3.64-8.43,5.47-13.22,5.47Zm0-36.31c-4.52,0-9.03,1.72-12.47,5.16-6.88,6.88-6.88,18.07,0,24.94,6.88,6.88,18.07,6.88,24.94,0,3.33-3.33,5.17-7.76,5.17-12.47s-1.84-9.14-5.17-12.47h0c-3.44-3.44-7.96-5.16-12.47-5.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m154.59,172.27c-.08,0-.16,0-.25-.02-.86-.14-1.45-.95-1.32-1.81.02-.14,2.22-14.08,5.71-27.69,6.59-25.74,11.97-28.16,15.41-27.71.87.11,1.48.9,1.38,1.77-.11.87-.91,1.48-1.77,1.37-5.62-.68-13.54,26.83-17.6,52.75-.12.78-.8,1.34-1.56,1.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m277.42,216.33c-.64,0-1.25-.39-1.48-1.03-16.85-45.37-63.19-57.64-63.66-57.76-.85-.22-1.36-1.08-1.14-1.92.21-.85,1.08-1.36,1.92-1.15.48.12,48.4,12.76,65.85,59.73.3.82-.11,1.73-.93,2.04-.18.07-.37.1-.55.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m282.09,305.78H126.55c-.87,0-1.58-.71-1.58-1.58s.71-1.58,1.58-1.58h155.54c.87,0,1.58.71,1.58,1.58s-.71,1.58-1.58,1.58Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m136.89,291.98h-64.04v-54.2c0-.58.47-1.06,1.06-1.06s1.06.47,1.06,1.06v52.09h61.93c.58,0,1.06.47,1.06,1.06s-.47,1.06-1.06,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m73.9,126.28c-.58,0-1.06-.47-1.06-1.06v-44.97h21.72c.58,0,1.06.47,1.06,1.06s-.47,1.06-1.06,1.06h-19.61v42.86c0,.58-.47,1.06-1.06,1.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 73.9,
    cy: 178.74,
    r: 59.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 73.9,
    cy: 178.74,
    r: 53.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m66.63,173.22c0-2.28-1.85-4.13-4.13-4.13s-4.13,1.85-4.13,4.13c0,2.1,1.57,3.83,3.6,4.1v17.38h1.07v-17.38c2.03-.26,3.6-1.99,3.6-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m57.87,218.54c0,2.28,1.85,4.13,4.13,4.13s4.13-1.85,4.13-4.13c0-2.1-1.57-3.83-3.6-4.1v-17.38h-1.07v17.38c-2.03.26-3.6,1.99-3.6,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m84.19,188.73c2-1.11,2.72-3.62,1.61-5.62-1.11-2-3.62-2.72-5.62-1.61-1.84,1.02-2.59,3.23-1.84,5.13l-15.2,8.43.52.94,15.2-8.43c1.21,1.65,3.49,2.18,5.33,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.31,203.03c-2,1.11-2.72,3.62-1.61,5.62,1.11,2,3.62,2.72,5.62,1.61,1.84-1.02,2.59-3.23,1.84-5.13l15.2-8.43-.52-.94-15.2,8.43c-1.21-1.65-3.49-2.18-5.33-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m78.71,212.06c1.9,1.26,4.47.74,5.73-1.16,1.26-1.9.74-4.47-1.16-5.73-1.75-1.16-4.06-.81-5.4.73l-14.48-9.61-.59.89,14.48,9.61c-.9,1.84-.33,4.1,1.42,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.79,179.7c-1.9-1.26-4.47-.74-5.73,1.16-1.26,1.9-.74,4.47,1.16,5.73,1.75,1.16,4.06.81,5.4-.73l14.48,9.61.59-.89-14.48-9.61c.9-1.84.33-4.1-1.42-5.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 61.37,
    cy: 195.7,
    r: 10.49,
    transform: "translate(-143.21 210.25) rotate(-76.66)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m95.57,139.54c0-1.37-1.11-2.48-2.48-2.48s-2.48,1.11-2.48,2.48c0,1.26.94,2.3,2.16,2.46v10.42h.64v-10.42c1.22-.16,2.16-1.2,2.16-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m90.31,166.72c0,1.37,1.11,2.48,2.48,2.48s2.48-1.11,2.48-2.48c0-1.26-.94-2.3-2.16-2.46v-10.43h-.64v10.43c-1.22.16-2.16,1.2-2.16,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m106.1,148.84c1.2-.66,1.63-2.17.97-3.37-.66-1.2-2.17-1.63-3.37-.97-1.1.61-1.55,1.94-1.1,3.08l-9.12,5.05.31.56,9.12-5.05c.73.99,2.09,1.31,3.19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m79.78,157.42c-1.2.66-1.63,2.17-.97,3.37.66,1.2,2.17,1.63,3.37.97,1.1-.61,1.55-1.94,1.1-3.08l9.12-5.05-.31-.56-9.12,5.05c-.73-.99-2.09-1.31-3.19-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m102.81,162.83c1.14.76,2.68.45,3.44-.7.76-1.14.45-2.68-.7-3.44-1.05-.7-2.44-.49-3.24.44l-8.69-5.76-.36.54,8.69,5.76c-.54,1.1-.2,2.46.85,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m83.07,143.42c-1.14-.76-2.68-.45-3.44.7-.76,1.14-.45,2.68.7,3.44,1.05.7,2.44.49,3.24-.44l8.69,5.76.36-.54-8.69-5.76c.54-1.1.2-2.46-.85-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m98.7,153.02c0,3.47-2.82,6.29-6.29,6.29s-6.29-2.82-6.29-6.29,2.82-6.29,6.29-6.29,6.29,2.82,6.29,6.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m59.93,150.56c0,3.53-2.86,6.4-6.4,6.4s-6.4-2.86-6.4-6.4,2.86-6.4,6.4-6.4,6.4,2.86,6.4,6.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 65.35,
    cy: 139.24,
    r: 2.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m107.06,195.34c0,1.57-1.27,2.84-2.84,2.84s-2.84-1.27-2.84-2.84,1.27-2.84,2.84-2.84,2.84,1.27,2.84,2.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 132.95,
    cy: 85.25,
    r: 38.38,
    transform: "translate(27.27 202.62) rotate(-80.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 132.95,
    cy: 85.25,
    r: 34.78,
    transform: "translate(-21.34 118.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m150.03,101.6h0c-4.11,3.75-10.54,3.47-14.29-.64l-20.12-22c-3.75-4.11-3.47-10.54.64-14.29h0c4.11-3.75,10.54-3.47,14.29.64l20.12,22c3.75,4.11,3.47,10.54-.64,14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m123.19,87.24l6.28,6.86c4.76-4.81,10.02-9.03,15.25-13.3l-5.64-6.17c-5.2,4.3-10.55,8.44-15.89,12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m141.28,77.04l-10.73-11.73c-3.75-4.11-10.18-4.39-14.29-.64h0c-4.11,3.75-4.39,10.18-.64,14.29l10.84,11.85c5.34-4.12,9.96-9.08,14.82-13.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m136.42,76.48c-.41.06-.85-.1-1.11-.47-5.39-7.63-9.49-9.35-11.98-9.45-2.64-.11-4.11,1.57-4.12,1.58-.4.48-1.12.55-1.61.14-.48-.4-.55-1.12-.14-1.61.09-.1,2.18-2.56,5.97-2.4,4.37.18,9,3.68,13.75,10.42.36.52.24,1.23-.27,1.59-.15.11-.32.17-.49.2Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m188.89,368.53c0-1.41.31-2.62.82-3.65h-122.13c-7.57,0-13.75,6.19-13.75,13.75v.74c0,7.57,6.19,13.75,13.75,13.75h121.31v-24.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m188.96,371.64c0-.99.28-1.84.75-2.56h-112.19c-6.95,0-12.64,4.35-12.64,9.68v.52c0,5.32,5.69,9.68,12.64,9.68h111.44v-17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m160.44,346.59c0-1.05.23-1.94.61-2.7h-90.61c-5.61,0-10.21,4.59-10.21,10.21v.55c0,5.61,4.59,10.21,10.21,10.21h90v-18.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m160.48,348.9c0-.74.21-1.37.56-1.9h-83.24c-5.16,0-9.38,3.23-9.38,7.18v.39c0,3.95,4.22,7.18,9.38,7.18h82.68v-12.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 70.3,
    y: 350.29,
    width: 90.18,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 70.3,
    y: 355.85,
    width: 90.18,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.33,
    y: 374.94,
    width: 121.65,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.33,
    y: 382.09,
    width: 121.65,
    height: 1
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "83.19 351.43 84.62 377.82 89.39 373.05 92.57 378.62 93.96 351.43 83.19 351.43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset25);
export default __webpack_public_path__ + "static/media/Asset 25.5244b7e93c4732b093301945bbd69127.svg";
export { ForwardRef as ReactComponent };